import { addDays, dateTimeToDate } from '@front-activerse/common-components';
import DateLineChart from '../../../Layout/Chart/DateLineChart';
import DateLineChartPlaceholder from '../../../Layout/Chart/DateLineChartPlaceholder';
import { withLoading } from '@front-activerse/common-components';

const HydrationHistoryChart = ({ dateFrom, dateTo, unit, days, defaultDailyGoal }) => {
  const goalData = new Map(
    days.map((day) => [
      dateTimeToDate(day.date).valueOf(),
      { x: dateTimeToDate(day.date), y: day.goalValue },
    ])
  );

  for (let date = dateFrom; date <= dateTo; date = addDays(date, 1)) {
    const key = dateTimeToDate(date).valueOf();
    if (!goalData.has(key)) {
      goalData.set(key, {
        x: dateTimeToDate(date),
        y: defaultDailyGoal,
      });
    }
  }

  const series = [
    {
      name: 'goal',
      meta: { showPoint: false, showLine: true },
      data: Array.from(goalData.values()),
    },
    {
      name: 'value',
      meta: { showPoint: false, showLine: false, showBar: true },
      data: days.map((day) => ({
        x: dateTimeToDate(day.date),
        y: day.valueValue,
      })),
    },
  ];

  const divisor = Math.min((dateTo - dateFrom) / 1000 / 60 / 60 / 24, 7);

  return (
    <DateLineChart
      series={series}
      options={{
        axisX: { divisor },
        axisY: { unit: unit, offset: 40, low: 0 },
      }}
    />
  );
};

export default withLoading(HydrationHistoryChart, DateLineChartPlaceholder);
